import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { ReserveGroup } from 'src/model/reserveGroup.model';
import { ReserveGroupService } from 'src/services/reserve-group.service';

@Component({
    selector: 'app-view-reserve-groups',
    templateUrl: './view-reserve-groups.component.html',
    styleUrls: ['./view-reserve-groups.component.scss'],
    standalone: false
})
export class ViewReserveGroupsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);
  private reserveGroupService = inject(ReserveGroupService);

  @Input() reserveGroupId: number

  reserveGroup: ReserveGroup;
  remark: string;

  simpanDate: Date;
  loggedInUserAccepted: boolean;
  loggedInCompanyId: number;

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];
  selectedAccountId: number;

  ngOnInit(): void {
    this.getReserveGroupDetails();
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));

    if (this.sharedService.isOperatingUser())
      this.getAllAccountsOfCompany(this.loggedInCompanyId);
  }

  async getReserveGroupDetails() {
    this.reserveGroup = await this.reserveGroupService.getReserveGroupDetails(this.reserveGroupId);
    const r = this.reserveGroup.Distribution.find(d => d.CompanyId === this.loggedInCompanyId);
    if (r !== undefined) this.loggedInUserAccepted = r.AcceptedOn !== undefined;
  }

  getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else {
            if (this.sharedService.isStaff()) {
              if (account.Username == loggedInUsername)
                this.cashAccountList.push(account);
            }
            else {
              this.cashAccountList.push(account);
            }
          }
        });
      }
    };
  }

  async viewReserveGroupImages(reserveGroupId: number) {
    const files = await this.reserveGroupService.getReserveGroupAllFiles(reserveGroupId);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
  }

  openUploadReserveGroupDocModal(reserveGroupId: number) {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.isReserveGroupDocument = true;
    modalRef.componentInstance.reserveGroupId = reserveGroupId;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const reserveGroupId = Number(entry);
    });
  }

  async acceptReserveGroup() {
    if (this.simpanDate == undefined || this.selectedAccountId == undefined) {
      this.sharedService.openAlert("Please select date and account!", ALERT_TYPE.DANGER)
    } else {
      await this.reserveGroupService.postAcceptReserveGroup(this.reserveGroupId, 'ACCEPTED FROM MAIN', this.selectedAccountId, this.simpanDate);
      this.sharedService.openAlert("Successfully added simpan distribution!", ALERT_TYPE.SUCCESS);
      this.activeModal.close();
    }
  }

  async submitReserveGroup() {
    await this.reserveGroupService.putSubmitReserveGroup(this.reserveGroup.ID);
    this.sharedService.openAlert("Reserve Group submitted", ALERT_TYPE.SUCCESS);
    this.activeModal.close();
  }

  reset() {
    this.activeModal.close();
  }
}
